import { useSelector } from 'react-redux';

import { getIsCommentsFilterActive } from 'src/redux/pull-request/selectors';

export const useCommentsFilterDetails = () => {
  const isCommentsFilterActive = useSelector(getIsCommentsFilterActive);
  return { isCommentsFilterActive };
};
